
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.74 12.456a.874.874 0 0 1-.067 1.304 1.063 1.063 0 0 1-1.323.019l-.09-.081-5-5.077a.87.87 0 0 1-.08-1.15l.08-.092 5-5.077a1.06 1.06 0 0 1 1.413-.062.873.873 0 0 1 .146 1.213l-.08.091-4.388 4.455 4.389 4.457Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\">\r\n<path d=\"M10.7399 12.456C11.1114 12.8332 11.0813 13.417 10.6727 13.7599C10.2954 14.0765 9.72754 14.0772 9.3502 13.7787L9.26005 13.6978L4.26006 8.62093C3.94221 8.29819 3.91572 7.81948 4.1806 7.47074L4.26006 7.37907L9.26005 2.30215C9.63156 1.92493 10.264 1.89713 10.6727 2.24006C11.0499 2.55661 11.1046 3.0784 10.8185 3.4535L10.7399 3.54401L6.351 7.99908L10.7399 12.456Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/arrow-left.9307bc8a63795c5c54f7da38f8583d83.svg"),
        {
          React: SvgArrowLeft,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      